import { html } from 'lit';

export const stopIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g>
      <rect x="5" y="5" fill="#EE333C" width="14" height="14" />
      <path fill="var(--vst-color-fg-primary)" d="M1,1v22h22V1H1z M21,21H3V3h18V31z" />
    </g>
  </svg>
`;
